export const { commit: commitHash } = require('../../../version.json');
export const { version: managerVersion } = require('../../../version.json');
